export default "__VITE_ASSET__lPseHCQy__"